export { ViewConfirmation } from './view-confirmation.component';
